import type { FaireProductEntity } from "../../entity_types/product";

export const p_wjbkbzy5gf: FaireProductEntity = {
  token: "p_wjbkbzy5gf",
  type: "product",
  name: "Helium Love Greeting Card Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/614b6227bfb600c2753596c597076d61a586a2f7ea464006cddd7c66c0b03bb2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/585748d846cd00b242a73fbff4116b48d7772e7c15b5f50eb08b628d958a2b5a.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:10.666Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
